import React from "react";
import { message, Button, Col, Form, Icon, Input, Row, Select, Radio, Divider } from "antd";
import img from "../../../assets/img/At the office-pana 1.png";
import MiCompAPI from "../../../util/api";
import TableWrapper from "../../elements/TableWrapper";

const { Option } = Select;
class FD extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      BORTemplate: [],
      title: this.props.eBOR ? "Update BOR" : "Add BOR",
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let { eBOR } = this.props;

        this.props.submitHandler({
          ...values,
          rules: values.val.map((x, i) => {
            return { key: this.state.BORTemplate[i].name, val: x }
          }),
          id: eBOR ? eBOR.id : 0,
        });
      }
    });
  };

  getClientMasters() {
    this.api.invoke(
      "GetMasters",
      "post",
      (data, success) => {
        if (success) {
          this.setState({
            BORTemplate: data.tier_rules,
          });
        }
      },
      ["MasterTierRule"]
    );
  }
  componentDidMount() {
    this.getClientMasters();
    let { eBOR } = this.props;
    const { setFieldsValue } = this.props.form;
    if (eBOR) {
      setFieldsValue({
        profileName: eBOR.profileName,
      });
    }
  }

  render() {
    const { eBOR } = this.props;
    const { getFieldDecorator } = this.props.form;
    const { BORTemplate } = this.state;

    return (
      <div className="mi_model_popup">
        <Row span={24}>
          <Col span={18}>
            <p style={{ marginLeft: "14px" }} className="mi_title">
              {this.state.title}
            </p>
          </Col>
          <Col span={6}>
            <i
              className="fa fa-times mi_icon mi_icon_red mi_button_close"
              style={{ color: "red" }}
              onClick={this.props.closeDrawerHandler}
            ></i>
          </Col>
        </Row>

        <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
          <Row span={24}>          
            <Col sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Profile Name</legend>
                  {getFieldDecorator("profileName", {
                    rules: [
                      {
                        required: true,
                        message: "Please enter Profile Name",
                      },
                      {
                        pattern: /^[a-zA-Z ]*$/,
                        message: "Profile Name should not contain special characters or numbers",
                      },
                    ],
                  })(
                    <Input
                      className="mi_input"
                      maxLength={40}
                      type="text"
                      placeholder="Please enter Profile Name *"
                    />
                  )}
                </fieldset>
              </Form.Item>
            </Col>
            <Col sm={24}>
              {BORTemplate.map((x, index) => {

                return <div style={{ margin: '0px 13px' }}><Row style={{ margin: '0px' }}><Col sm={24}   >
                  <Form.Item>
                    {x.name}</Form.Item>
                </Col><Col md={6} sm={24}  >
                    <Form.Item>
                      {getFieldDecorator(`val[${index}]`, {
                        initialValue: eBOR ? eBOR.rules[index] && eBOR.rules[index].val : undefined,
                        rules: [

                          {
                            required: true,
                            message: (
                              <span style={{ marginTop: "-6px !important" }}>
                                Please Select Rule.
                              </span>
                            ),
                          },
                        ],
                      })(
                        <Radio.Group>
                          <Radio value={true}>Yes</Radio>
                          <Radio value={false}>No</Radio>
                        </Radio.Group>
                      )}
                    </Form.Item>
                  </Col></Row> </div>
              })}
            </Col>
          </Row>

          <Row span={24} style={{ marginTop: "30px" }}>
            <Col span={7}></Col>

            <Col span={5}>
              <Button
                className="mi_button_right submit-button"
                onClick={this.props.closeDrawerHandler}
                style={{ marginRight: 8 }}
              >
                Cancel
              </Button>
            </Col>
            <Col span={5}>
              <Button
                htmlType="submit"
                className="submit-button"
                type="primary"
              >
                Submit
              </Button>
            </Col>
            <Col span={7}>
              <img
                alt="example"
                style={{
                  height: "70px",
                  marginBottom: "-30px",
                  float: "right",
                }}
                src={img}
              />
            </Col>
            <Col span={7}></Col>
          </Row>
        </Form>
      </div>
    );
  }
}
const AddBORT = Form.create()(FD);
export default AddBORT;
